export default {
  hasExistingSubscription: 'loginsubscription',
  hasDuplicateAccount: 'logindup',
  shouldFulfill: 'loginoffer',
};
